export const NAME_LIMIT_MAX = 255;
export const DESCRIPTION_LIMIT_MAX = 1500;
export const URL_LIMIT_MAX = 2048;
export const NO_VALUE = 'No value set-';
